<template>
  <div class="filtrate-container custom-side-filter">
    <transition name="van-fade">
      <div v-show="visible" class="mask" @click="close"></div>
    </transition>

    <transition name="van-slide-right">
      <div class="side wrap" v-show="visible">
        <div class="main">
          <van-cell
            title="校区"
            is-link
            :value-class="['van-ellipsis', campusText ? 'selected':'']"
            :value="campusText || '请选择'"
            @click="chooseCampus"
          />
          <van-cell
            title="课程"
            is-link
            :value-class="['van-ellipsis', curriculumText ? 'selected':'']"
            :value="curriculumText || '请选择'"
            @click="chooseCourse"
          />
          <van-cell
            title="课时包"
            is-link
            :value-class="['van-ellipsis', params.universalCardInfoId ? 'selected':'']"
            :value="params.universalCardInfoId?params.universalCard.name:'请选择'"
            @click="chooseCard"
          />
          <van-cell
            title="班级"
            is-link
            :value-class="['van-ellipsis', classText ? 'selected':'']"
            :value="classText || '请选择'"
            @click="chooseClass"
          />
          <div class="three-a-row" style="padding-bottom: 0">
            <div class="nav-title">学员跟进人</div>
            <div
              class="nav-div"
              style="padding-bottom: calc(var(--gap) * 8); margin-bottom: 0"
            >
              <div class="nav-box">
                <div
                  class="item-nav"
                  :class="{ active: params.hasFollowTeacher === 1 }"
                  @click="triggerAssignStatus(1)"
                >
                  有跟进人
                </div>
              </div>
              <div class="nav-box">
                <div
                  class="item-nav"
                  :class="{ active: params.hasFollowTeacher === 0 }"
                  @click="triggerAssignStatus(0)"
                >
                  无跟进人
                </div>
              </div>
            </div>
          </div>
          <van-cell
            title="跟进人"
            v-if="!config.noFollowTeacher && params.hasFollowTeacher === 1"
            is-link
            :value-class="['van-ellipsis', followTeacher ? 'selected':'']"
            :value="followTeacher||'请选择'"
            @click="chooseTeacher"
          />
          <van-cell
            title="教务老师"
            is-link
            :value-class="['van-ellipsis', jiaowuTeacher ? 'selected':'']"
            :value="jiaowuTeacher||'请选择'"
            @click="chooseJiaowuTeacher"
          />
          <div class="three-a-row">
            <div class="nav-title">上次提醒时间</div>
            <div class="date-box">
              <input-date-range :start="params.noticeStartTime" :end="params.noticeEndTime" @change="chooseCalendar"></input-date-range>
            </div>
          </div>
        </div>
        <van-row class="footer" gutter="12">
          <van-col span="12">
            <van-button block square round @click="reset"> 重置 </van-button>
          </van-col>
          <van-col span="12">
            <van-button block square round type="primary" @click="confirm">
              确定
            </van-button>
          </van-col>
        </van-row>
      </div>
    </transition>
  </div>
</template>

<script>
import InputDateRange from '@x3/vue/comp/input-date-range.vue';

let defaultParams = {
  // 校区ids
  campusIds: [],
  campusList: [],
  // 课程id集合
  curriculumIds: [],
  curriculumList: [],
  universalCardInfoId: '',
  universalCard: {},
  // 班级id集合
  classIds: [],
  classList: [],
  noticeStartTime: '',
  noticeEndTime: '',
  // 分配状态/意向跟进状态， 0未分配/无跟进人，1已分配/有跟进人
  hasFollowTeacher: '',
  // 跟进人ID集合
  followTeaIds: [],
  followTeaList: [],
  // 教务老师id集合
  jiaowuTeaIds: [],
  jiaowuTeaList: [],
  followTeacherIdsMap: { //学员跟进人(筛选条件) 1教务老师 2销售老师	
    1: [],
    2: [],
  },
};

export default {
  name: "feeWarnFiltrate",
  components: {
    InputDateRange
  },
  data() {
    return {
      visible: false,
      tagList: [],
      params: JSON.parse(JSON.stringify(defaultParams)),
      config: {},
    };
  },
  computed: {
    campusText: function () {
      let cps = this.params.campusList,
        text = "";
      if (cps.length == 1) {
        text = cps[0].name;
      } else if (cps.length > 1) {
        text = `${cps.length}个校区`;
      }
      return text;
    },
    curriculumText: function () {
      if (this.params.curriculumList[0]) {
        return this.params.curriculumList[0].curriculumName;
      } else {
        return "";
      }
    },
    classText: function () {
      if (this.params.classList[0]) {
        return this.params.classList[0].className;
      } else {
        return "";
      }
    },
    followTeacher: function () {
      let tcs = this.params.followTeaList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
    jiaowuTeacher: function () {
      let tcs = this.params.jiaowuTeaList,
        text = '';
      if (tcs.length == 1) {
        text = tcs[0].name;
      } else if (tcs.length > 1) {
        text = `${tcs.length}个老师`;
      }
      return text;
    },
  },
  methods: {
    prevInit() {
      if (!this.$route.meta._resolve) {
        setTimeout(() => {
          this.$router.back();
        }, 0);
      } else {
        let opts = this.$route.meta.options || {};
        this._resolve = this.$route.meta._resolve;
        this._reject = this.$route.meta._reject;
        if (opts.config) {
          this.config = Object.assign(this.config, opts.config);
        }
        if (opts.params) {
          let params = JSON.parse(JSON.stringify(opts.params));
          this.params = Object.assign(this.params, params);
        }

        setTimeout(() => {
          this.visible = true;
        }, 0);
      }
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList
      });

      let oIdsStr = this.params.campusIds.join(),
        nOdsStr = res.ids.join();
      // 如果选中的校区发生变化
      if (oIdsStr != nOdsStr) {
        this.params.campusIds = res.ids;
        this.params.campusList = res.list;

        this.params.curriculumIds = [];
        this.params.curriculumList = [];

        this.params.universalCardInfoId = '';
        this.params.universalCard = {};

        this.params.classIds = [];
        this.params.classList = [];
      }
    },
    // 选择课程
    async chooseCourse() {
      let res = await app.x3.side.xsCourse({
        id: this.params.curriculumIds[0],
      });

      this.params.curriculumIds = res ? [res.curriculumId] : [];
      this.params.curriculumList = res ? [res] : [];

      this.params.classIds = [];
      this.params.classList = [];
    },
    // 选择课时包
    async chooseCard() {
      let ret = await app.x3.side.xsCard({
        id: this.params.universalCardInfoId,
        params: {
          campusIds: this.params.campusIds,
        },
      });
      this.params.universalCard = ret;
      this.params.universalCardInfoId = ret ? ret.id : '';
    },
    // 选择班级
    async chooseClass() {
      let res = await app.x3.side.xsClass({
        id: this.params.classIds[0],
        params: {
          campusIds: this.params.campusIds,
          campusList: this.params.campusList,
          curriculumIds: this.params.curriculumIds,
          classStatus: "",
        },
        config: {
          radio: true, 
          enableFilter: false,
        },
        filter: {
          enableCampusFilter: false,
        }
      });
      this.params.classIds = res ? [res.id] : [];
      this.params.classList = res ? [res] : [];
    },
    async chooseCalendar(ret) {
      this.params.noticeStartTime = ret.startDate
      this.params.noticeEndTime = ret.endDate
    },
    triggerAssignStatus(id) {
      this.params.hasFollowTeacher = this.params.hasFollowTeacher === id ? '' : id;
      this.params.followTeaIds = [];
      this.params.followTeaList = [];
      this.params.followTeacherIdsMap[2] = [];
    },
    // 选择跟进人
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.followTeaIds,
        list: this.params.followTeaList,
      });
      this.params.followTeaIds = res.ids;
      this.params.followTeaList = res.list;
      this.params.followTeacherIdsMap[2] = res.ids;
    },
    // 选择教务老师
    async chooseJiaowuTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.jiaowuTeaIds,
        list: this.params.jiaowuTeaList,
      });
      this.params.jiaowuTeaIds = res.ids;
      this.params.jiaowuTeaList = res.list;
      this.params.followTeacherIdsMap[1] = res.ids;
    },
    // 重置
    async reset() {
      this.params = JSON.parse(JSON.stringify(defaultParams));
    },
    render() {
      this.$api.tagList().then((res) => {
        this.tagList = res.data;
      });
    },
    doneAnima() {
      this.$router.back();
      return new Promise((rsv) => {
        setTimeout(() => {
          rsv();
        }, 100);
      });
    },
    async close() {
      await this.doneAnima();
    },
    async confirm() {
      await this.doneAnima();
      let params = JSON.parse(JSON.stringify(this.params));
      this._resolve(
        JSON.parse(
          JSON.stringify({
            params,
          })
        )
      );
    },
  },
  created() {
    this.prevInit();
    this.render();
  },
  watch: {
    "$vxRoute.vx_action": function (nv, ov) {
      if (nv == "vx-out") {
        this.visible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filtrate-container {
  background: transparent;
  .mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(var(--black-rgb), 0.7);
    z-index: 1;
  }
  .side {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: var(--x3-slide-left);
    background: var(--g1);
    z-index: 2;
  }
  .wrap {
    display: flex;
    flex-direction: column;
    font-size: var(--fs-md);
    color: var(--g8);
    background: var(--white);
    .main {
      flex: 1;
      overflow-y: auto;
      .nav-wrapper {
        margin-left: calc(var(--gap) * 16);
        .nav-title {
          padding: calc(var(--gap) * 8) calc(var(--gap) * 16)
            calc(var(--gap) * 16) 0;
          font-size:var(--fs-md);
          line-height:var(--lh-md);
        }
      }
    }
  }
}
</style>